module.exports = __webpack_public_path__ + "img/monthly.107a8450.png";